import React from "react";
import { PiggyBank } from "lucide-react";
import { finApi, money } from "@/lib/financeApi";
import { Chip, ErrorBox, FinRoster, Loading, useLoad, useView } from "@/components/nds/windows/finance/parts";
import FinSavingsDetail from "@/components/nds/windows/finance/FinSavingsDetail";

export default function FinSavingsContent() {
  const [view, setView] = useView("savings_view");
  const [selected, setSelected] = React.useState(null);
  const [state, load] = useLoad(() => Promise.all([finApi.get("/residents", { status: view }), finApi.get("/savings/requests", { status: "pending" })])
    .then(([r, q]) => {
      const pending = {};
      q.requests.forEach((x) => { pending[x.resident_id] = (pending[x.resident_id] || 0) + 1; });
      return { ...r, pending };
    }), [view]);

  if (selected) return <FinSavingsDetail resident={selected} onBack={() => { setSelected(null); load(); }} />;
  return (
    <div data-testid="fin-savings-content" className="flex flex-col h-full">
      {state.loading && !state.data ? <Loading testid="fin-savings-loading" label="Loading savings…" />
        : state.error ? <ErrorBox testid="fin-savings-error" error={state.error} onRetry={load} />
        : (
          <FinRoster prefix="fin-savings" icon={PiggyBank} view={view} setView={setView} counts={state.data.counts}
            residents={state.data.residents} onOpen={setSelected} onRefresh={load}
            renderRight={(r) => {
              const n = state.data.pending[r.id] || 0;
              const bal = r.balances.savings;
              return (
                <>
                  {n > 0 && <Chip tone="yellow" data-testid={`fin-savings-pending-${r.id}`}>{n} pending</Chip>}
                  <span data-testid={`fin-savings-balance-${r.id}`} className={`font-mono text-sm w-28 text-right ${bal > 0 ? "text-nex-gold" : bal < 0 ? "text-red-300" : "text-nex-muted"}`}>{money(bal)}</span>
                </>
              );
            }} />
        )}
    </div>
  );
}
